import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { AbstractAnalyticsService } from '@abstract-services/analytics/1.0/analytics.abstract-service';
import {
  CustomDimensionsPartial,
  DataLayerService,
} from '@services/data-layer/1.0/data-layer.service';

// TODO: Implement custom dimensions based on Tillster spec.
@Injectable()
export class AnalyticsService implements AbstractAnalyticsService {
  constructor(
    private dataLayer: DataLayerService,
    private router: Router,
  ) {}

  updateCustomDimensions(dimensions: CustomDimensionsPartial): void {
    this.dataLayer.dimensions = dimensions;
  }

  pageView(pathOverride?: string): void {
    this.dataLayer.trigger();
    (window as any).dataLayer.push({
      event: 'virtualPageView',
      virtualPageURL: pathOverride || this.router.url,
      virtualPageTitle: pathOverride || this.router.url,
    });
  }

  pageViewWithCustomDimensions(dimensions: CustomDimensionsPartial): void {
    this.updateCustomDimensions(dimensions);
    this.pageView();
  }

  init(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.pageView();
      }
    });
  }
}
